import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import HomeIcon from '@mui/icons-material/Home';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import Popover from '@mui/material/Popover';
import { signout } from "../../redux/features/loginSlice";
import { RootState } from "../../redux/store/store";
import { Link } from "react-router-dom";

import "./Header.scss";

interface HeaderComponentProps {
  onLogoClick?: () => void;
  notifications?: Array<{ PartID: string; PartName: string; Username?: string }>;
  onNotificationClick?: (part: any) => void;
}

const HeaderComponent = ({ onLogoClick, notifications = [], onNotificationClick }: HeaderComponentProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useSelector((state: RootState) => state.login);
  const { userName } = userData;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | SVGSVGElement | null>(null);
  const notificationOpen = Boolean(anchorEl);

  const handleSignout = () => {
    localStorage.clear();
    window.location.href = "/login";
    dispatch(signout()); // remove user credentials from redux
    navigate("/");
  };

  const handleLogoClick = () => {
    if (onLogoClick) {
      onLogoClick();
    }
  };

  const handleNotificationIconClick = (event: React.MouseEvent<SVGSVGElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationClose = () => {
    setAnchorEl(null);
  };

  const handleNotificationItemClick = (part: any) => {
    handleNotificationClose();
    if (onNotificationClick) {
      onNotificationClick(part);
    }
  };

  return (
    <div className="header-container">
      <div className="logo-container">
        <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}></div>
        <div className="divider"></div>
        <HomeIcon className="home-icon" onClick={handleLogoClick} style={{ cursor: 'pointer' }} />
      </div>
      <div className="user-name">
        {/*<Badge badgeContent={notifications.length} color="error" className="notification-badge">
          <NotificationsIcon 
            className="notification-icon" 
            onClick={handleNotificationIconClick}
            style={{ cursor: 'pointer', fontSize: '28px', color: '#fff' }}
          />
  </Badge>
        <Popover
          open={notificationOpen}
          anchorEl={anchorEl}
          onClose={handleNotificationClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          slotProps={{
            paper: {
              sx: {
                mt: 1,
                minWidth: 320,
                maxHeight: 400,
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
              },
            },
          }}
        >
          <div className="notification-panel">
            <div className="notification-header">
              <h3>Notifications</h3>
              <span className="notification-count">{notifications.length}</span>
            </div>
            <div className="notification-list">
              {notifications.length === 0 ? (
                <div className="no-notifications">No new notifications</div>
              ) : (
                notifications.map((part, index) => (
                  <div 
                    key={index}
                    className="notification-item"
                    onClick={() => handleNotificationItemClick(part)}
                  >
                    <div className="notification-content">
                      <div className="notification-title">{part.PartName}</div>
                      <div className="notification-subtitle">Created by: {part.Username || 'Unknown'}</div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
                </Popover>*/}
        <div className="divider"></div>
        <label>Welcome! {userName}</label>
        <span className="arrow"></span>
        <div className="sign-out" onClick={handleSignout}></div>
      </div>
    </div>
  );
};

export default HeaderComponent;
